
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router';

//import service
import pservice from '@/core/services/PublicService';

export default defineComponent({
    name: "public-sport-teams-nominal",
    setup() {
        const loading = ref(false)
        const route = useRoute();
        const { idevent, idsport, idteam } = route.params
        const listNominal = ref <any>([])

        const getNominal = async () => {
            loading.value = true
            await pservice.Nominal({
                source: 1,
                evento: idevent,
                sport: idsport,
                club: idteam
            })
                .then((res) => {
                    listNominal.value = res.data
                    loading.value = false
                }).catch(({ response }) => { loading.value = false })

        }

        onMounted(() => {
            getNominal()
        })

        return {
            loading,
            idevent, idsport, idteam,
            listNominal

        }
        
    },
})
